module.exports = __webpack_public_path__ + "static/img/hou4.a8cb85a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/hou4.png
// module id = hdv3
// module chunks = 0